import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Theme,
  makeStyles,
  createStyles,
  DialogTitle,
  TextField,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      margin: theme.spacing(1),
      minWidth: "400px",
      width: "100%",
    },
    addButton: {
      marginTop: theme.spacing(2),
      textAlign: "center",
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

/** Webクロール除外URL登録ダイアログ状態 インタフェース */
export interface WebCrawlingAddExcludedUrlDialogState {
  open: boolean;
  webClawlingErrorId: number | null;
  excludedUrl: string;
}

interface Props {
  state: WebCrawlingAddExcludedUrlDialogState;
  onOpenChange: (
    // webClawlingConfigId?: number,
    webClawlingErrorId?: number,
    url?: string
  ) => void;
  onUrlChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onAddExcludedUrlClick: () => void;
}

/** Webクロール除外URL登録ダイアログ */
export function WebCrawlingAddExcludedUrlDialog(props: Props) {
  const classes = useStyles();

  const { state, onUrlChange, onAddExcludedUrlClick, onOpenChange } = props;

  //--------------------
  // コンポーネント
  return (
    <Dialog
      open={state.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">
        除外URL登録
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            onOpenChange();
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          id="outlined-required"
          className={classes.input}
          label="登録URL"
          variant="outlined"
          size="small"
          onChange={onUrlChange}
          value={state.excludedUrl}
        />
        <div className={classes.addButton}>
          <Button
            variant="contained"
            size="small"
            onClick={onAddExcludedUrlClick}
            color="primary"
            autoFocus
          >
            除外URLに追加
          </Button>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          size="small"
          onClick={() => {
            onOpenChange();
          }}
          // color="primary"
          autoFocus
        >
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
}
